import { Component, Pipe, PipeTransform, OnInit } from '@angular/core';
import { DecimalPipe } from '@angular/common';
import { GeneralStatusService } from '../../services/general-status.service';
interface ServerStats {
  totalMemoryMB: string;
  usedMemoryMB: string;
  memoryUsagePercentage: string;
  cpuUsagePercentage: string;
  networkUsage: string;
  diskUsagePercentage: string;
  mysqlStats: MySQLStats;
  incidents: number;
  incidents_sended: number;
  incidents_actives: number;
  incidents_archived: number;
  installations: number;
  dashboards: number;
  cuadros: number;
  subsecciones: number;
}

interface MySQLStats {
  connections: number;
  abortedConnects: number;
  queries: number;
}
@Component({
  selector: 'app-os-info',
  standalone: true,
  imports: [DecimalPipe],
  templateUrl: './os-info.component.html',
  styleUrl: './os-info.component.scss',
})
export class OsInfoComponent implements OnInit {
  currentInfo?: ServerStats;

  constructor(private service: GeneralStatusService) {}
  ngOnInit(): void {
    this.getCurrentInfo();
    setInterval(() => {
      this.getCurrentInfo();
    }, 3000);
  }

  getCurrentInfo() {
    this.service.getServerStats().subscribe((res) => {
      this.currentInfo = res;
    });
  }
}
